import { css } from 'styled-components'

const extendStylesDropdownTrans = css`
    /* width: 306px; */
    width: 514px;
`

export { extendStylesDropdownTrans }
